// Ao clicar no card da Gran no quadro de faturas: escolher entre a visão de sempre
// (o quadro filtrado só com as faturas da Gran) e a Planilha Gran nova.
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FileSpreadsheet, LayoutList, Leaf, X } from 'lucide-react';

interface Props {
  isOpen: boolean;
  nomeEmpresa: string;
  onClose: () => void;
  onQuadro: () => void;
  onPlanilha: () => void;
  onSoVigor: () => void;
  /** Sem empresa Gran identificada a planilha não abre (só há o filtro de sempre). */
  planilhaDisponivel: boolean;
}

const EscolhaVisaoGranModal: React.FC<Props> = ({ isOpen, nomeEmpresa, onClose, onQuadro, onPlanilha, onSoVigor, planilhaDisponivel }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const opcao = 'w-full text-left flex items-start gap-3 p-3 rounded-xl border transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50';

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in" role="dialog" aria-modal="true" aria-labelledby="escolha-gran-titulo">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-4 space-y-3">
        <div className="flex items-center justify-between">
          <h2 id="escolha-gran-titulo" className="text-[15px] font-bold text-gray-900 dark:text-white">Faturas da {nomeEmpresa}</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" aria-label="Fechar"><X className="w-4 h-4" /></button>
        </div>

        <button autoFocus onClick={onPlanilha} disabled={!planilhaDisponivel} className={`${opcao} border-orange-200 bg-orange-50 hover:bg-orange-100 dark:border-orange-900/50 dark:bg-orange-900/15 dark:hover:bg-orange-900/25 disabled:opacity-50 disabled:cursor-not-allowed`}>
          <FileSpreadsheet className="w-5 h-5 text-orange-600 dark:text-orange-400 shrink-0 mt-0.5" aria-hidden="true" />
          <span>
            <span className="block text-[13px] font-semibold text-gray-900 dark:text-white">Planilha {nomeEmpresa}</span>
            <span className="block text-[12px] text-gray-600 dark:text-gray-300">Condomínios e extras do mês, conferência, emissão em sequência e a planilha para enviar à {nomeEmpresa}.</span>
          </span>
        </button>

        <button onClick={onQuadro} className={`${opcao} border-gray-200 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800`}>
          <LayoutList className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" aria-hidden="true" />
          <span>
            <span className="block text-[13px] font-semibold text-gray-900 dark:text-white">Quadro de faturas</span>
            <span className="block text-[12px] text-gray-600 dark:text-gray-300">Como já era: o quadro mostra só as faturas da {nomeEmpresa}.</span>
          </span>
        </button>

        <button onClick={onSoVigor} className="w-full inline-flex items-center justify-center gap-1.5 pt-1 text-[12px] font-medium text-gray-500 hover:text-emerald-700 dark:hover:text-emerald-400">
          <Leaf className="w-3.5 h-3.5" aria-hidden="true" /> Ver só as faturas da Vigor
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default EscolhaVisaoGranModal;
